export class OnBehalfOf {
    readonly customer: number;
    readonly contact: number | null;

    constructor(customer: number, contact?: number | null) {
        this.customer = customer;
        this.contact = contact ?? null;
    }

    toString(): string {
        return this.contact !== null ? `${this.customer}:${this.contact}` : `${this.customer.toString()}`;
    }
}